export const agentQueryKeys = {
  all: ["agents"],
  list: (params: {
    pageSize: number;
    pageNumber: number;
    sort: "created" | "-created";
    tenantId?: string;
    status?: "active" | "archived" | "all" | null;
  }) => [...agentQueryKeys.all, "list", params],
  infinite: (params: {
    pageSize: number;
    sort: "created" | "-created";
    tenantId?: string;
    status?: "active" | "archived" | "all" | null;
    inAgentPools?: boolean | null;
    moduleName?: string | null;
    hostOs?: string | null;
    agentVersion?: string | null;
  }) => [...agentQueryKeys.all, "infinite", params],
  byId: (id: string) => [...agentQueryKeys.all, "id", id],
  byModule: (moduleName: string) => [...agentQueryKeys.all, "module", moduleName],
  byModuleVersion: (moduleName: string, moduleVersion: string) => [
    ...agentQueryKeys.byModule(moduleName),
    "version",
    moduleVersion,
  ],
};
